module.exports = "/_next/static/images/EngineeringExpertise-5f4ec337430972aff7e5ce6260e8ac5f.webp";